var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import OpportunityService from "../../../Services/Opportunity.service";
import ChangeStageForm from "./ChangeStageForm";
import useUniqueId from "../../Hooks/useUniqueId";
import ShowMoreList, { StringShowMoreListRenderer, } from "../../UI/ShowMoreList/ShowMoreList";
import { MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL } from "../../Container/Pipeline/PipelineDetailListMenu";
const ChangeStageModal = (_a) => {
    var { opportunities, pipelineId } = _a, modalProps = __rest(_a, ["opportunities", "pipelineId"]);
    const opportunityIds = opportunities.map((o) => o.id);
    const makeId = useUniqueId()[1];
    return (_jsxs(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Change Stage", handleSubmit: (state) => OpportunityService.bulkUpdateStage(opportunityIds, state.stage.id, pipelineId), children: [_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: makeId("opportunities"), children: ["Opportunities (", opportunities.length, ")"] }), _jsx("div", { id: makeId("opportunities"), children: _jsx(ShowMoreList, { numOfItemsToPreview: MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL, renderer: StringShowMoreListRenderer, items: opportunities.map((o) => o === null || o === void 0 ? void 0 : o.subject.fullName) }) })] }), _jsx(ChangeStageForm, { pipelineId: pipelineId })] })));
};
export default ChangeStageModal;
